import { BooleanFilterEnum } from '../../../enums/boolean-filter.enum';
import { ApiRequestFilters } from '../../../types/api-request-filters';

/**
 * Languages filters
 */
export class LanguagesFilters extends ApiRequestFilters {
	/**
	 * Hidden value
	 */
	hidden?: BooleanFilterEnum;
}
